const environments = ["Dev", "Qas", "Prod"];
const domains = ["fem.jtcqas.gov.sg/", "fem.jtcqas.gov.sg/", "fem.jtc.gov.sg/"];
const domains_intranet = ["fem-i.jtcqas.gov.sg/", "fem-i.jtcqas.gov.sg/", "fem-i.jtc.gov.sg/"];
const captchaSiteKey = 
  [
    "6LfKfAErAAAAAPJfxl0XF4D5Bo1MmsQtzaBqSvL_", 
    "6LfKfAErAAAAAPJfxl0XF4D5Bo1MmsQtzaBqSvL_",  // QA and Dev Share the same key
    "6Leds-AhAAAAAIcivXJQIKZJ95qlHNeuHT-mGDrB",  
  ];
// ============================================= MODIFY HERE ============================================
var _envKey = 1; // Default value
 
// ============================================= MODIFY HERE ============================================
const constants = {
  //=============================================================== >>>>>
  env_: environments[_envKey],
  domain: `https://${domains[_envKey]}`,
  domain_intranet: `https://${domains_intranet[_envKey]}`,
  domain_withoutHttps: `${domains[_envKey]}`,
  domain_intranet_withoutHttps: `${domains_intranet[_envKey]}`,
  //=============================================================== >>>>>
  version__: "0.6.4", // Do Change Version @ package.json file as well.
  version__date: "2023/6/6", // yyyy/mm/dd FORMAT ONLY || To show "What's New" (Refer to What's New Dialog Options below)
  //=============================================================== >>>>>
  prefix_url: "/",
  userAccountLockedFeasCode: 1010113,
  userAccountDisabledFeasCode: 1010105,
  userAccountSamePasswordForPasswordChange: 1010134,
  userAccountInvalidCode: 1010188,   
    //=============================================================== >>>>>  googleRecaptcha
  googleRecaptcha:{
    disabled: false,
    scoreTolerance:0.3,
    sitekey:captchaSiteKey[_envKey],
   },
  //=============================================================== >>>>>  Indicate page is from "Logout" Function (MUINavbar)
  logout_channel: "$_logout/", // not in use.
  //=============================================================== >>>>>  Inactivity Settings
  allowedInactivity: 1200000, // in ms // 300000 //1200000
  warningIn: 60000, // in ms
  isInactivityFeatureOn: true,
  //=============================================================== >>>>> What's New Dialog Options ( NOT IN USE - NOT NEEDED ) - Need to inject the WhatsNewComponent to page if using.
  WhatsNewSettingOn: false,
  WhatsNewShowAlways: false, // No Matter what, show it
  WhatsNewDaysToShowContinuously: 2,
  WhatsNewShowAfterEveryInMinutes: 120,
  WhatsNewItems: [
    "View IRA Workflow at Incident Page",
    "Concurrency Control",
    "Review bug fixed (Validation Required at Reviewer Name)",
    "Incident Status for an incident requires user to include incident in management report",
    "Incident Versions will be saved after sending to management report",
    "UI improvements of Other Details at Incident Page",
    "Email Sending Bug fixed ('\\n issues')",
    "Download PDF contains images and PDF documents",
    "Users can view the incident at IRA after clicking on 'Click to see more' at the Email Report.",
  ],

  //=============================================================== >>>>> Maintenance...
  ShowMaintenance: false,
  MaintenanceIsShowAlways: true,
  MaintenanceMessage:
    "FEMS2.0 will be undergoing scheduled maintenance from 6.30 pm to 7.30 pm on 24 December 2023 and will not be accessible during this period. We apologise for any inconvenience caused. Please Contact BSD for more information.",
};

export default Object.freeze(constants);
